<div class="container-fluid">
	<div class="row align-items-end my-3">
		<div class="col">
			<h1 class="text-capitalize">Configuraciones de Ticket</h1>
		</div>
		<div class="col-auto">
			<a class="btn btn-primary" [routerLink]="['/add-ticket-config']">Agregar Configuracion</a>
		</div>
	</div>

	<app-loading [is_loading]="is_loading"></app-loading>

	<div class="card" *ngIf="!is_loading">
		<div class="table-responsive">
			<table class="table table-hover mb-0">
				<thead class="thead-light">
					<tr>
						<th>Nombre</th>
						<th>Encabezado</th>
						<th>Pie</th>
						<th class="text-end">Acciones</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngIf="ticket_list.length === 0">
						<td colspan="4" class="text-center text-muted py-4">
							No hay configuraciones de ticket.
							<a [routerLink]="['/add-ticket-config']">Crear una</a>
						</td>
					</tr>
					<tr *ngFor="let ticket of ticket_list">
						<td>{{ ticket.name }}</td>
						<td>
							<span *ngIf="ticket.header" class="text-truncate d-inline-block" style="max-width: 200px;">
								{{ ticket.header }}
							</span>
							<span *ngIf="!ticket.header" class="text-muted">-</span>
						</td>
						<td>
							<span *ngIf="ticket.footer" class="text-truncate d-inline-block" style="max-width: 200px;">
								{{ ticket.footer }}
							</span>
							<span *ngIf="!ticket.footer" class="text-muted">-</span>
						</td>
						<td class="text-end">
							<a class="btn btn-sm btn-outline-primary me-1" [routerLink]="['/edit-ticket-config', ticket.id]">
								Editar
							</a>
							<button class="btn btn-sm btn-outline-danger" (click)="deleteTicket(ticket)">
								Eliminar
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>
